import React, {useReducer, useEffect} from 'react'
import {Button, Card, H3, Row} from '../../UI/index.js'
import {formSpacing, ColorPicker, FormRow, FormStack, Input, Select, Toggle} from '../../UI/forms/index.js'
import {Activity} from '../../../../server/functions/resellers/resellers.types.js'
import Languages from '../../../../utils/Languages.js'

interface EditActivityProps {
    activity: Activity
    onSave: (activity: Activity) => void
    onCancel: () => void
}

interface ActivitiesState {
    activity: Activity
    validation: {
        name: boolean
    }
}

const EditActivity = (props: EditActivityProps) => {
    const {onSave} = props

    const [state, setState] = useReducer((state: ActivitiesState, newState: Partial<ActivitiesState>) => ({...state, ...newState}), {
        activity: props.activity,
        validation: {
            name: false
        }
    })

    useEffect(() => {
        if (!props.activity.name) {
            document.getElementById('activityName')?.focus()
        }

        setState({activity: props.activity})
    }, [props.activity])

    return (
        <Card shadow style={{display: 'flex', flexDirection: 'column', padding: 20, width: 600, height: 'fit-content', maxHeight: 'calc(100vh - 120px)'}}>
            <H3 style={{marginBottom: 36}}>{state.activity?.name}</H3>

            <FormStack style={{marginBottom: formSpacing.rowGap}}>
                <FormRow gap={formSpacing.tight}>
                    <ColorPicker
                        value={state.activity?.color}
                        onChange={(event) => {
                            setState({activity: {...state.activity!, color: event.target.value}})
                        }}
                    />

                    <Input
                        id='activityName'
                        label={Languages.name['NL']}
                        value={state.activity?.name}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setState({activity: {...state.activity!, name: event.target.value}})
                        }}
                        isInvalid={state.validation.name}
                    />
                </FormRow>

                <Select
                    label='Automatisch actief tijdens'
                    info='Start deze activiteit automatisch bij de gekozen actie.'
                    options={[
                        {value: 'loading', title: 'Inladen van route'},
                        {value: 'route', title: 'Route rijden'},
                        {value: 'other', title: 'Overige'}

                    ]}
                    value={state.activity?.trigger}
                    onChange={(event) => {
                        setState({activity: {...state.activity!, trigger: event.target.value as '' | 'loading' | 'route' | 'other'}})
                    }}
                    allowEmpty
                />

                <Toggle
                    label='Alleen automatisch activeren'
                    info='Deze activiteit kan alleen automatisch geactiveerd worden, en kan niet handmatig gestart worden.'
                    checked={state.activity?.automaticOnly}
                    onChange={(event) => {
                        setState({activity: {...state.activity!, automaticOnly: event.target.checked}})
                    }}
                />

                <Toggle
                    label='App functionaliteit vergrendelen tijdens deze activiteit'
                    checked={state.activity?.lockAppActivity}
                    onChange={(event) => {
                        setState({activity: {...state.activity!, lockAppActivity: event.target.checked}})
                    }}
                />
            </FormStack>

            <Row style={{justifyContent: 'flex-end', marginTop: 20}}>
                <Button onClick={() => onSave(state.activity!)}>Opslaan</Button>
            </Row>
        </Card>
    )
}

EditActivity.displayName = 'EditActivity'

export default EditActivity
